export default "__VITE_ASSET__BM3ZE9VW__"